// Types
import { HiddenAlertProps } from './HiddenAlert.types';

// Styles
import styles from './hidden-alert.scss';

const HiddenAlert = ({ text = '' }: HiddenAlertProps) =>
  text && (
    <span className={styles.visuallyHidden} role="alert">
      {text}
    </span>
  );

export default HiddenAlert;
